export default "__VITE_ASSET__C281aMcH__"